import { z } from 'zod';

import { DocumentTypeSchema } from './document-type';
import { DocumentUserSchema } from './document-user';

export const DocumentSiteSchema = z.object({
  name: z.string(),
  siteId: z.string(),
});

export type DocumentSite = z.infer<typeof DocumentSiteSchema>;

export const BaseDocumentSchema = z.object({
  id: z.string(),
  type: DocumentTypeSchema,
  name: z.string().min(1),
  tags: z.array(z.string()),
  sites: z.array(DocumentSiteSchema),
});

export const DocumentSchema = BaseDocumentSchema.merge(
  z.object({
    required: z.boolean(),
    uploadedBy: DocumentUserSchema,
    updatedAt: z.date(),
    isGlobal: z.boolean(),
    file: z.object({
      name: z.string(),
      extension: z.string(),
    }),
  }),
);

export type Document = z.infer<typeof DocumentSchema>;

export const MissingDocumentSchema = BaseDocumentSchema;

export type MissingDocument = z.infer<typeof MissingDocumentSchema>;

export const DocumentCreateSchema = BaseDocumentSchema.omit({
  id: true,
  sites: true,
}).merge(
  z.object({
    isGlobal: z.boolean(),
    file: z.instanceof(File),
  }),
);

export type DocumentCreate = z.infer<typeof DocumentCreateSchema>;

export const DocumentUpdateSchema = BaseDocumentSchema.partial().extend({
  id: z.string().min(1),
  siteIds: z.array(z.string()).optional(),
});

export type DocumentUpdate = z.infer<typeof DocumentUpdateSchema>;
